<template>
  <div class="company-select" ref="root">
    <div
      class="company-select__trigger"
      :class="{ 'company-select__trigger--open': open, 'company-select__trigger--has-value': modelValue.length > 0 }"
      tabindex="0"
      @click="toggle"
      @keydown.enter.prevent="toggle"
      @keydown.space.prevent="toggle"
      @keydown.esc="close"
    >
      <div class="company-select__chips">
        <span
          v-for="item in modelValue"
          :key="item.id"
          class="company-select__chip"
          @click.stop
        >
          {{ item.name }}
          <button type="button" class="company-select__chip-remove" @click.stop="remove(item)" aria-label="הסר">×</button>
        </span>
        <span v-if="modelValue.length === 0" class="company-select__placeholder">בחרו חברה / לוגו</span>
      </div>
      <span class="company-select__arrow" :class="{ 'company-select__arrow--up': open }">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>

    <div v-if="open" class="company-select__dropdown">
      <div class="company-select__search-wrap">
        <input
          ref="searchInput"
          v-model="query"
          class="company-select__search"
          placeholder="חיפוש..."
          type="text"
          @keydown.esc="close"
        />
        <button
          type="button"
          class="company-select__add-btn"
          @click.stop="showAddModal = true"
        >
          <span class="company-select__add-icon">+</span>
          <span class="company-select__add-label--full">הוספת לוגו חדש</span>
          <span class="company-select__add-label--short">הוספה</span>
        </button>
      </div>
      <div class="company-select__list">
        <div v-if="loading" class="company-select__empty">טוען...</div>
        <div v-else-if="filtered.length === 0 && query" class="company-select__empty">לא נמצאו תוצאות</div>
        <label
          v-for="item in filtered"
          :key="item.id"
          class="company-select__option"
          :class="{ 'company-select__option--selected': isSelected(item) }"
        >
          <input
            type="checkbox"
            :checked="isSelected(item)"
            @change="toggleItem(item)"
            class="company-select__checkbox"
          />
          <span class="company-select__option-name">{{ item.name }}</span>
          <span v-if="isSelected(item)" class="company-select__check">✓</span>
        </label>
      </div>
    </div>

    <AddCompanyModal
      v-if="showAddModal"
      @close="showAddModal = false"
      @created="onCompanyCreated"
    />
  </div>
</template>

<script>
import AddCompanyModal from './AddCompanyModal.vue';

export default {
  name: 'CompanySelect',
  components: { AddCompanyModal },
  props: {
    modelValue: { type: Array, default: () => [] },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      open: false,
      query: '',
      companies: [],
      loading: false,
      showAddModal: false,
    };
  },
  computed: {
    filtered() {
      if (!this.query.trim()) return this.companies;
      const q = this.query.trim().toLowerCase();
      return this.companies.filter((c) => c.name.toLowerCase().includes(q));
    },
  },
  mounted() {
    this.loadCompanies();
    document.addEventListener('mousedown', this.onOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('mousedown', this.onOutsideClick);
  },
  methods: {
    loadCompanies() {
      this.loading = true;
      this.api({ method: 'get', action: 'my_linktones/companies_list' }, (res) => {
        const list = res && res.data ? res.data : res;
        this.companies = Array.isArray(list) ? list : [];
        this.loading = false;
      }, () => { this.loading = false; });
    },
    toggle() {
      this.open ? this.close() : this.openDropdown();
    },
    openDropdown() {
      this.open = true;
      this.query = '';
      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus();
      });
    },
    close() {
      this.open = false;
      this.query = '';
    },
    isSelected(item) {
      return this.modelValue.some((s) => s.id === item.id);
    },
    toggleItem(item) {
      if (this.isSelected(item)) {
        this.$emit('update:modelValue', this.modelValue.filter((s) => s.id !== item.id));
      } else {
        this.$emit('update:modelValue', [...this.modelValue, { id: item.id, name: item.name }]);
      }
    },
    remove(item) {
      this.$emit('update:modelValue', this.modelValue.filter((s) => s.id !== item.id));
    },
    onOutsideClick(e) {
      if (this.$refs.root && !this.$refs.root.contains(e.target)) {
        this.close();
      }
    },
    onCompanyCreated(company) {
      this.companies.push({ id: company.id, name: company.name });
      this.$emit('update:modelValue', [...this.modelValue, { id: company.id, name: company.name }]);
      this.showAddModal = false;
    },
  },
};
</script>
